// initial state
const state = () => ({
    jobs: [],
})

// actions
const actions = {
    fetchJobs: async({ commit }) => {
        return await axios.get('job').then(({ data }) => {
            commit('setJobs', data);
            return data;
        }).catch(({ response }) => {
            throw response.data;
        });
    },

    removeJob: async({ commit }, id) => {
        return await axios.delete(`job/${id}`).then(({ data }) => {
            commit('removeJob', id);
            return data;
        }).catch(({ response }) => {
            throw response.data;
        });
    },

    getJob: async({ commit }, id) => {
        return await axios.get(`job/${id}`).then(({ data }) => {
            commit('addJob', data);
            return data;
        }).catch(({ response }) => {
            throw response.data;
        });
    }
}

// mutations
const mutations = {
    setJobs: (state, jobs) => {
        state.jobs = jobs;
    },

    addJob: (state, job) => {
        state.jobs.push(job);
    },

    updateJob: (state, job) => {
        let index = state.jobs.findIndex(j => j.id === job.id);
        state.jobs[index] = job;
    },

    removeJob: (state, id) => {
        let index = state.jobs.findIndex(j => j.id === id);
        state.jobs.splice(index, 1);
    }
}

const getters = {
    unreadJobCount: state => {
        return state.jobs.filter(job => !job.seen_at).length;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
